/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { getTargetIndex } from "cms/forms/form-layout/context/question-list.context/get-target-index";
import { useCallback } from "react";
import { ComponentPositionContext } from "./component-position.context";


/**
 * Controls operations against a list of questions.
 * @type {import('react').FC<ComponentPositionProviderProps>}
 */
export const ComponentPositionProvider = (props) => {
    const {
        children,
        sortableMethods,
        numComponents
    } = props;

    const move = useCallback(
        /**
         * @type {ComponentPositionContext['move']}
         */
        (direction, id, sourceIndex) => {
            const targetIndex = getTargetIndex(direction, sourceIndex, numComponents);

            sortableMethods.swapItems(id, targetIndex);
            sortableMethods.onDrop();
        },
        [numComponents, sortableMethods]
    );

    /**
     * @type {ComponentPositionContext}
     */
    const ctx = {
        move,
    };

    return (
        <ComponentPositionContext.Provider value={ctx}>
            {children}
        </ComponentPositionContext.Provider>
    );
};
